import React from 'react';
import { Link } from 'react-router-dom';
export const TopSellingBrands = () => {
  const brands = [{
    name: 'Apple',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg',
    slug: 'apple'
  }, {
    name: 'Samsung',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg',
    slug: 'samsung'
  }, {
    name: 'Huawei',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/e/e8/Huawei_Logo.svg',
    slug: 'huawei'
  }, {
    name: 'OPPO',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0c/OPPO_LOGO_2019.svg',
    slug: 'oppo'
  }, {
    name: 'Xiaomi',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ae/Xiaomi_logo_%282021-%29.svg',
    slug: 'xiaomi'
  }, {
    name: 'Google',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg',
    slug: 'google'
  }, {
    name: 'Vivo',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Vivo_logo_2019.svg',
    slug: 'vivo'
  }, {
    name: 'OnePlus',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f1/OnePlus_Logo.svg',
    slug: 'oneplus'
  }, {
    name: 'Sony Xperia',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Xperia_Logo.svg',
    slug: 'sony'
  }, {
    name: 'Razer',
    logo: 'https://upload.wikimedia.org/wikipedia/en/4/40/Razer_snake_logo.svg',
    slug: 'razer'
  }, {
    name: 'Nothing',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Nothing_logo.svg',
    slug: 'nothing'
  }];
  return <section className="py-12" data-id="element-1311">
      <div className="container mx-auto px-4" data-id="element-1312">
        <h2 className="text-3xl font-bold text-gray-800 mb-8" data-id="element-1313">
          Top Selling Brands
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4" data-id="element-1314">
          {brands.map(brand => <Link key={brand.slug} to={`/category/${brand.slug}`} className="bg-white border border-gray-100 rounded-lg p-4 flex items-center justify-center h-28 hover:shadow-md hover:scale-105 transition-all duration-200" data-id="element-1315">
              <img src={brand.logo} alt={`${brand.name} logo`} className="max-h-12 max-w-full" data-id="element-1316" />
            </Link>)}
        </div>
      </div>
    </section>;
};